const deviation = (A, S) => Math.abs(A - S);

/**
 * Limit fixed at 10 MWh (40 MW * 0.25 hours)
 */
const getLimitMWh = () => 10;

// --------------------------------------------------
// Band 1: Up to 10 MWh (Settled at Frequency-linked NR)
// --------------------------------------------------
export const calcDSM_0_10 = (A, S, f, NR) => {

  // --------------------------------------------------
  // ZERO SCHEDULE CASE (ADDED ONLY)
  // --------------------------------------------------
  if (S === 0) {
    const DEV = Math.abs(A);

    if (DEV <= 0) return 0;

    const block = DEV;

    if (A > 0) {
      // Over-drawal
      if (f < 49.90) return -block * NR * 1.50 * 10;
      if (f < 50.00) return -block * NR * (1.0 + Math.round((50.00 - f) / 0.01) * 0.05) * 10;
      if (f === 50.00) return -block * NR * 1.00 * 10;
      if (f <= 50.05) return -block * NR * Math.max(0.75, 1.0 - Math.round((f - 50.00) / 0.01) * 0.05) * 10;
      if (f < 50.10) return -block * NR * 0.50 * 10;
      return 0;
    } else {
      // Under-drawal / Injection
      if (f >= 50.10) return -block * NR * 0.10 * 10;
      if (f > 50.05) return 0;

      if (f > 50.00) {
        const steps = Math.round((f - 50.00) / 0.01);
        return block * NR * Math.max(0.50, 0.90 - (steps * 0.08)) * 10;
      }

      if (f >= 49.90) {
        const steps = Math.round((50.00 - f) / 0.01);
        return block * NR * Math.min(1.00, 0.90 + (steps * 0.01)) * 10;
      }

      return block * NR * 1.00 * 10;
    }
  }

  // --------------------------------------------------
  // EXISTING LOGIC (UNCHANGED)
  // --------------------------------------------------
  if (!S) return 0;

  const L1 = getLimitMWh();
  const DEV = deviation(A, S);

  const block = Math.min(DEV, L1);
  if (block <= 0) return 0;

  if (A > S) {
    // Over-drawal: Band 1
    if (f < 49.90) return -block * NR * 1.50 * 10;
    if (f < 50.00) return -block * NR * (1.0 + Math.round((50.00 - f) / 0.01) * 0.05) * 10;
    if (f === 50.00) return -block * NR * 1.00 * 10;
    if (f <= 50.05) return -block * NR * Math.max(0.75, 1.0 - Math.round((f - 50.00) / 0.01) * 0.05) * 10;
    if (f < 50.10) return -block * NR * 0.50 * 10;
    return 0;
  } else {
    // Under-drawal: Band 1 (Frequency-linked steps)
    if (f >= 50.10) return -block * NR * 0.10 * 10;
    if (f > 50.05) return 0;

    if (f > 50.00) {
      const steps = Math.round((f - 50.00) / 0.01);
      return block * NR * Math.max(0.50, 0.90 - (steps * 0.08)) * 10;
    }

    if (f >= 49.90) {
      const steps = Math.round((50.00 - f) / 0.01);
      return block * NR * Math.min(1.00, 0.90 + (steps * 0.01)) * 10;
    }

    return block * NR * 1.00 * 10;
  }
};

// --------------------------------------------------
// Band 2: Beyond 10 MWh (Settled at 0.80 NR for Under-drawal)
// --------------------------------------------------
export const calcDSM_10_15 = (A, S, f, NR) => {
  if (!S) return 0;

  const L1 = getLimitMWh();
  const DEV = deviation(A, S);

  const block = Math.max(DEV - L1, 0);
  if (block <= 0) return 0;

  if (A > S) {
    // Over-drawal: Band 2
    if (f < 50.00) return -block * NR * 2.00 * 10;
    if (f < 50.10) return -block * NR * 1.00 * 10;
    return -block * NR * 0.50 * 10;
  } else {
    // Under-drawal: Band 2 (Flat 0.80 NR)
    if (f >= 50.10) return -block * NR * 0.10 * 10;
    if (f > 50.05) return 0;
    return block * NR * 0.80 * 10;
  }
};

// --------------------------------------------------
// Band 3: Always 0 for this category
// --------------------------------------------------
export const calcDSM_15 = (A, S, f, NR) => {
  return 0;
};
